import { render, staticRenderFns } from "./MerchandiseReport.vue?vue&type=template&id=40c8a7f8"
import script from "./MerchandiseReport.vue?vue&type=script&lang=js"
export * from "./MerchandiseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports